import { Icon, IconProps } from '@chakra-ui/react'

const RushGemIcon = ({ width = '20px', height = '20px' }: IconProps) => {
  return (
    <Icon
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.3396 7.96289L8.8064 17.7363H8.79761L1.92944 7.96289H5.3396ZM13.4822 7.96289L10.0154 17.7363H9.98608L6.51831 7.96289H13.4822ZM11.2009 17.7363H11.1941L14.6609 7.96289H18.0701L11.2009 17.7363ZM18.2341 6.85156H14.7126L13.2722 2.59277H15.6794L18.2341 6.85156ZM5.28784 6.85156H1.76538L4.32104 2.59277H6.72925L5.28784 6.85156ZM12.0994 2.59277L13.5398 6.85156H6.46069L7.90112 2.59277H12.0994Z"
        fill="currentColor"
      />
    </Icon>
  )
}

export default RushGemIcon
